export const LS_KEY_CHART_ANNOTATIONS = 'chart_annotations';
export const defaultCandleBandwith = 5;
export const xAxisBuffer = 0.8;
export const initialDisplayCandleCount = 100;
export const initialDisplayCandleCountForMobile = 30;
export const xAxisHeightPixel = 32;
export const mainCanvasElementId = 'main-canvas';
